import clsx from "clsx";

import type { CardBackground, CardRadius } from "@/puck/types";

const BACKGROUND_CLASSES: Record<CardBackground, string> = {
  voiceCard: "bg-marketing-voice-card",
  softBlue: "bg-gail-primary-light",
  white: "bg-white",
  surface: "bg-marketing-surface",
};

const RADIUS_CLASSES: Record<CardRadius, string> = {
  xl: "rounded-xl",
  "2xl": "rounded-2xl",
  "3xl": "rounded-3xl",
};

export type SectionBackground = CardBackground | "none";

export type CardSurfaceOptions = {
  background?: CardBackground;
  radius?: CardRadius;
  bordered?: boolean;
};

export function getCardSurfaceClasses({
  background = "voiceCard",
  radius = "2xl",
  bordered = true,
}: CardSurfaceOptions = {}): string {
  return clsx(
    BACKGROUND_CLASSES[background],
    RADIUS_CLASSES[radius],
    bordered && "border border-black/5",
  );
}

export function getColumnSectionWrapperClasses({
  background = "none",
  radius = "2xl",
}: {
  background?: SectionBackground;
  radius?: CardRadius;
} = {}): string {
  if (background === "none") {
    return "";
  }

  return clsx(
    getCardSurfaceClasses({ background, radius, bordered: false }),
    "relative overflow-visible px-6 py-10 md:px-10 md:py-12 lg:px-14 lg:py-14",
  );
}

export function normalizeSectionBackground(
  value: SectionBackground | undefined,
): SectionBackground {
  if (value && (value === "none" || value in BACKGROUND_CLASSES)) {
    return value;
  }

  return "none";
}

export function normalizeCardBackground(
  value: CardBackground | undefined,
): CardBackground {
  if (value && value in BACKGROUND_CLASSES) {
    return value;
  }

  return "voiceCard";
}

export function normalizeCardRadius(value: CardRadius | undefined): CardRadius {
  if (value && value in RADIUS_CLASSES) {
    return value;
  }

  return "2xl";
}
